import { Component, Input } from '@angular/core';
import { IonicPage, Platform, NavController, NavParams, ModalController, AlertController, ViewController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
import { Market } from '@ionic-native/market';

import { AccountPage } from '../account/account';
import { ForgotPage } from '../forgot/forgot';
import { TabsPage } from '../tabs/tabs';
import { CreatewallPage } from '../createwall/createwall';
import { NotifipopupPage } from '../notifipopup/notifipopup';

// import * as $ from "jquery";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-login',
    templateUrl: 'login.html',
    providers: [HttpService]
})
export class LoginPage {
    @Input() data: any;
    @Input() events: any;

    language: string = 'en';
    texts: any = [];
    lang_list: any = [];
    lang_list_i: number;
    servermode: string;

    company: string = 'FUNTRA';
    server: string = 'http://cms.funtra.net/mobile/';
    test: string = 'http://funtra.ddsapp.net/mobile/';

    chucheon_base_url: string = 'http://cms.funtra.net/tree/chucheon/';
    test_chucheon_base_url: string = 'http://funtra.ddsapp.net/tree/chucheon/';
    line_base_url: string = 'http://cms.funtra.net/tree/line/';
    test_line_base_url: string = 'http://funtra.ddsapp.net/tree/line/';
    huwon_base_url: string = 'http://cms.funtra.net/tree/huwon/';
    test_huwon_base_url: string = 'http://funtra.ddsapp.net/tree/huwon/';

    mode: string = 'test';
    id: string;
    password: string;
    server_name: string = '';
    android_appid: string = '';
    ios_appid: string = '';
    version: string = '2.0.0';
    remember: boolean = true;

    office_email: string;
    email: string;
    unit: string;
    coin_unit: string = 'TRX';
    token_unit: string = 'DBC';
    coin_name: string = 'Tron';
    bonus_unit: string = 'Tron';
    point_unit: string = 'POINT';
    btc_unit: string = 'BTC';
    usdt_unit: string = 'USDT';
    usdt_name: string = 'BSC';
    badges: string;

    private isIdValid: boolean = true;
    private isPasswordValid: boolean = true;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpService,
        public modalCtrl: ModalController,
        private alertCtrl: AlertController,
        public viewCtrl: ViewController,
        public toastCtrl: ToastController,
        private market: Market,
        private plt: Platform,
        private app: App,
    ) {

    }

    ionViewWillEnter() {
        //// 로그인 정보를 지운다.
        localStorage.removeItem("loginId");
        localStorage.removeItem("api_key");
        localStorage.removeItem("HTTPService");
        localStorage.removeItem("server_name");

        if (this.mode == "main") {
            localStorage.setItem("HTTPService", this.server);
            localStorage.setItem("servermode", "Y");
        } else {
            this.server_name = "TEST";
            localStorage.setItem("HTTPService", this.test);
            localStorage.setItem("servermode", "N");
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "login");
        localStorage.setItem("version", this.version);
        localStorage.setItem("company", this.company);
        localStorage.setItem("server_name", this.server_name);
        localStorage.setItem("android_appid", this.android_appid);
        localStorage.setItem("ios_appid", this.ios_appid);
        localStorage.setItem("mode", this.mode);
        localStorage.setItem("chucheon_base_url", this.chucheon_base_url);
        localStorage.setItem("test_chucheon_base_url", this.test_chucheon_base_url);
        localStorage.setItem("line_base_url", this.line_base_url);
        localStorage.setItem("test_line_base_url", this.test_line_base_url);
        localStorage.setItem("huwon_base_url", this.huwon_base_url);
        localStorage.setItem("test_huwon_base_url", this.test_huwon_base_url);

        // if (!localStorage.getItem("reLoginId")) {
        //     this.id = localStorage.getItem("reLoginId");
        // } else {
        //     this.id = ""
        // }

        this.id = localStorage.getItem("reLoginId");

        // localStorage.setItem("language", this.language);
        let language = localStorage.getItem('language');
        if (language == '' || language == undefined || language == null){
        	language = this.language;
        localStorage.setItem("language",this.language);
        } else {
        	this.language = language;
        }

        // this._createDiv();

        // this._get_texts();

        this._notice().then(() => {
            this._get_texts();
        });
    }

    _changeLanguage() {
        setTimeout(() => {
            localStorage.setItem("language", this.language);
            this._lang_set();
        }, 250);
    }

    _lang_set() {
        this._lang_list().then((res: any) => {
            this._lang(res).then((res: any) => {
                this._get_texts();
            });
        }, (err) => {
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err.message,
                buttons: ['OK']
            });
            alert.present();

        });
    }

    _lang_list() {
        return new Promise((resolve, reject) => {
            let url = "common/language/list";
            let body = JSON.stringify({
                lang: this.language
            });
            this.http.post(url, body).then((res: any) => {
                if (res.result == "OK") {
                    this.lang_list = res.list;
                    let lang_list_i = this.lang_list.findIndex(i => i.code == this.language);
                    resolve(lang_list_i);
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            }, (err) => {
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: JSON.stringify(err),
                    buttons: ['OK']
                });
                alert.present();
                reject(err);
            });
        });
    }

    _lang(i) {
        return new Promise((resolve, reject) => {
            let url = "common/language/json";
            let body = JSON.stringify({
                path: this.lang_list[i].path,
            });
            this.http.post(url, body).then((res: any) => {
                if (res.result == "OK") {
                    let lang_pack = res.language[0];
                    localStorage.removeItem('lang_pack');
                    localStorage.setItem('lang_pack', JSON.stringify(lang_pack));
                    resolve(res);
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            }, (err) => {
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: err.message,
                    buttons: ['OK']
                });
                alert.present();
                reject(err);
            });
        });

    }

    _get_texts() {
        this.texts = JSON.parse(localStorage.getItem('lang_pack')).login;
    }

    _notice() {
        return new Promise((resolve, reject) => {
            let url = "common/notice";
            let body = JSON.stringify({
                language: this.language,
            });

            this.http.post(url, body).then((res: any) => {
                if (res.result == "OK") {
                    this.lang_list = res.language;
                    let lang_pack = res.json[0];
                    localStorage.removeItem('lang_pack');
                    localStorage.setItem('lang_pack', JSON.stringify(lang_pack));
                    resolve(lang_pack);
                    if (res.list == undefined) {
                        return;
                    } else {
                        let modal = this.modalCtrl.create(NotifipopupPage, { list: res.list });
                        modal.present();
                    }
                } else {
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }

            }, (err) => {
                //// HTTP 에러인 경우
                let alert = this.alertCtrl.create({
                    message: err,
                    buttons: ['OK']
                });
                alert.present();

            });
        });
    }

    _event = (event: string): void => {
        if (event == "register") {
            this.navCtrl.push(AccountPage);
        }
        if (event == "forgot") {
            this.navCtrl.push(ForgotPage);
        }
        if (event == "login") {
            if (this._validate()) {

                let body = JSON.stringify({
                    id: this.id.toLocaleLowerCase(),
                    password: this.password,
                    version: this.version,
                    language: this.language
                });

                this.http.post("login", body).then((res: any) => {
                    if (res.result == "OK") {
                        // this.id = res.id
                        localStorage.setItem("api_key", res.api);
                        this.office_email = res.office_email;
                        this.email = res.email;
                        this.unit = res.unit;
                        this.coin_unit = res.coin_unit;
                        // this.cash_room_unit = res.cash_room_unit;
                        // this.bonus_room_unit = res.bonus_room_unit;
                        this.badges = res.badges;
                        localStorage.setItem('email', this.email);
                        localStorage.setItem('office_email', this.office_email);
                        localStorage.setItem('unit', res.unit);
                        localStorage.setItem('coin_unit', res.coin_unit);
                        localStorage.setItem('bonus_unit', res.bonus_unit);
                        localStorage.setItem('btc_unit', this.btc_unit);
                        localStorage.setItem('point_unit', this.point_unit);
                        localStorage.setItem('usdt_unit', this.usdt_unit);
                        localStorage.setItem('usdt_name', this.usdt_name);
                        localStorage.setItem('token_unit', this.texts.token_unit);

                        localStorage.setItem("id", this.id.toLocaleLowerCase());
                        localStorage.setItem("loginId", this.id.toLocaleLowerCase());

                        localStorage.removeItem("reLoginId");
                        localStorage.setItem("reLoginId", this.id.toLocaleLowerCase());

                        // this._joinChat(res.api);

                        this.navCtrl.setRoot(TabsPage);
                    } else if (res.result == "NO_WALLET") {
                        localStorage.setItem("api_key", res.api);

                        localStorage.setItem("id", this.id.toLocaleLowerCase());
                        localStorage.setItem("loginId", this.id.toLocaleLowerCase());

                        localStorage.removeItem("reLoginId");
                        localStorage.setItem("reLoginId", this.id.toLocaleLowerCase());

                        this.navCtrl.setRoot(CreatewallPage, { id: this.id });

                    } else if (res.result == "MISMATCH_VERSION") {

                        let alert = this.alertCtrl.create({
                            message: res.message,
                            buttons: ['OK']
                        });
                        alert.present();
                        this._store();

                    } else if (res.result === "LOGOUT") {
                        let alert = this.alertCtrl.create({
                            message: res.message,
                            buttons: ['OK']
                        });
                        alert.present();
                        localStorage.removeItem("loginId");
                        this.app.getRootNav().setRoot(LoginPage);

                    } else {

                        let alert = this.alertCtrl.create({
                            message: res.message,
                            buttons: ['OK']
                        });
                        alert.present();
                    }
                }, (err) => {

                    let alert: any;
                    if (err.status == 0) {
                        alert = this.alertCtrl.create({
                            message: err.message,
                            buttons: ['OK']
                        });
                    } else {
                        alert = this.alertCtrl.create({
                            message: err,
                            buttons: ['OK']
                        });
                    }
                    alert.present();
                });
            }
        }

    }

    _validate(): boolean {
        this.isIdValid = true;
        this.isPasswordValid = true;

        if (!this.id || this.id.length == 0) {
            this.isIdValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_id,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return;
        }

        if (!this.password || this.password.length == 0) {
            this.isPasswordValid = false;
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_password,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            return;
        }

        return this.isIdValid && this.isPasswordValid;
    }

    _store() {
        let appId;

        if (this.plt.is("ios")) {
            appId = this.ios_appid;
        } else {
            appId = this.android_appid;
        }

        this.market.open(appId).then(response => {
            console.debug(response);

        }).catch(error => {
            console.warn(error);
        });
    }

    _noti() {
        let modal = this.modalCtrl.create(NotifipopupPage);
        modal.present();
        modal.onDidDismiss(idx => {
            if (idx == "" || idx == undefined || idx == null) {
                return;
            } else {

            }
        });
    }

    // _joinChat(api) {
    // 	this.socket.connect();
    // 	this.socket.emit("register", {
    // 		key: 'wTmHJ~DclIaR0ianPB',
    // 		api: api,
    // 		id: this.id,
    // 	});
    // }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts